/** Public export for the WHO HAS ACCESS group line (SE-8359). */
export { default } from "./ShareGroupAccessRowContainer";
export type { ShareGroupAccessRowContainerProps } from "./ShareGroupAccessRowContainer";
